import { Link } from "react-router-dom";
import FlowerButton from "@/components/FlowerButton";

export default function PaymentCancel() {
  return (
    <div className="max-w-3xl mx-auto px-6 lg:px-10 py-20 text-center">
      <h1 className="font-cursive text-6xl md:text-7xl text-[#78353A] leading-none">Paiement annulé</h1>
      <p className="mt-4 text-[#4A3B32]/85">Pas de souci, ton panier est toujours là.</p>
      <div className="mt-8 flex justify-center gap-4 flex-wrap">
        <Link to="/panier"><FlowerButton>Retour au panier</FlowerButton></Link>
        <Link to="/boutique"><FlowerButton variant="sage">La boutique</FlowerButton></Link>
      </div>
    </div>
  );
}
